"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementTitle = void 0;
var tslib_1 = require("tslib");
function getElementTitle(projectId, dfRef, attrElementUriOrPrimaryLabel, ctx) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var queryOptions, validElementsQuery;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryOptions = {
                        elements: ctx.backend.capabilities.supportsElementUris
                            ? {
                                uris: [attrElementUriOrPrimaryLabel],
                            }
                            : {
                                primaryValues: [attrElementUriOrPrimaryLabel],
                            },
                    };
                    return [4 /*yield*/, ctx.backend
                            .workspace(projectId)
                            .attributes()
                            .elements()
                            .forDisplayForm(dfRef)
                            .withLimit(1)
                            .withOptions(queryOptions)
                            .query()];
                case 1:
                    validElementsQuery = _a.sent();
                    return [2 /*return*/, validElementsQuery.items[0].title];
            }
        });
    });
}
exports.getElementTitle = getElementTitle;
//# sourceMappingURL=getElementTitle.js.map